import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const Navbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navTo = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => navTo('/')} style={{ cursor: 'pointer' }}>
        <img src="/logo.png" alt="IndustriQuote" />
      </div>

      {/* Hamburger Toggle */}
      <button
        className={`navbar-hamburger ${isMenuOpen ? 'active' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <div className="hamburger-box">
          <span />
          <span />
          <span />
        </div>
      </button>

      {/* Navigation Links & Contact - Desktop */}
      <div className="navbar-desktop-content">
        <div className="navbar-links">
          <button onClick={() => navTo('/3d-configurator')}>3D Sensor</button>
          <button onClick={() => navTo('/engineering-drawing')}>DRAFTER</button>
          <button onClick={() => navTo('/gears')}>Gears</button>
          <button onClick={() => navTo('/about')}>About</button>
          <button onClick={() => navTo('/how-it-works')}>How It Works</button>
        </div>

        <div className="navbar-contact-container">
          <a className="navbar-contact" href="mailto:info@IndustriQuote.com">
            <span className="navbar-contact-dot" />
            <span className="navbar-contact-text">info@IndustriQuote.com</span>
          </a>
          <a className="navbar-contact" href="tel:7732073269">
            <span className="navbar-contact-dot" />
            <span className="navbar-contact-text">(773) 207-3269</span>
          </a>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`navbar-mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-links">
          <div className="mobile-menu-section-title">Company</div>
          <button onClick={() => navTo('/how-it-works')}>How It Works</button>
          <button onClick={() => navTo('/about')}>About IndustriQuote</button>

          <div className="mobile-menu-section-title">Modules</div>
          <button onClick={() => navTo('/3d-configurator')}>3D WaveMaster Sensor</button>
          <button onClick={() => navTo('/engineering-drawing')}>2D Drawing Template</button>
          <button onClick={() => navTo('/gears')}>Parametric Gear Designer</button>

          <div className="mobile-menu-section-title">Contact</div>
          <a className="navbar-contact" href="mailto:info@IndustriQuote.com">
            <span className="navbar-contact-dot" />
            info@IndustriQuote.com
          </a>
          <a className="navbar-contact" href="tel:7732073269">
            <span className="navbar-contact-dot" />
            (773) 207-3269
          </a>
        </div>
      </div>

      {/* Subnavbar - Separate row underneath */}
      <div className="subnavbar">
        <div className="subnavbar-text">
          <span className="subnavbar-dot" />
          <span>Last updated 04/24/2026 08:47 AM</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
